export function redirect404(to) {
  return {
    path: '/404',
    query: {path: to.fullPath}
  }
}



// WEBPACK FOOTER //
// ./src/utils/redirect404.js